import { IconOctagonX } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { StopTarget } from '../lib/taskStop';
import { ConfirmDialog } from './ConfirmDialog';

// Stop confirmation for one task (#1906, spec §3.6 tinted destructive action) —
// pure presenter; the parent owns the mutation. `task === null` keeps the dialog
// closed. A failed stop surfaces as the parent's error toast while the dialog
// stays open, so the destructive action never silently no-ops.
//
// The body NAMES the task and its repo rather than an id: a confirm that asks
// someone to verify `tsk_9f3c…` is a confirm they will click through, which is
// how the wrong row gets stopped.

export type StopTaskModalProps = {
  readonly task: StopTarget | null;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
};

export function StopTaskModal(props: StopTaskModalProps): JSX.Element {
  return (
    <ConfirmDialog
      open={props.task !== null}
      title={t('fleet.stop.title')}
      desc={t('fleet.stop.body', {
        title: props.task?.title ?? '',
        repo: props.task?.repo_full_name ?? '',
      })}
      media={<IconOctagonX />}
      cancelLabel={t('fleet.stop.cancel')}
      actionLabel={t('fleet.stop.confirm')}
      destructive
      onCancel={props.onClose}
      onConfirm={props.onConfirm}
    />
  );
}
